module.exports = __webpack_public_path__ + "static/media/html.b016b301.png";